import type { FaireProductEntity } from "../../entity_types/product";

export const p_7e8ve7bfhs: FaireProductEntity = {
  token: "p_7e8ve7bfhs",
  type: "product",
  name: "Angel Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/75e6a339b1357ffab9c1bef28b80303e8fcc28d0de1be13e23f94a94ccb5d641.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/91b7987fcf4ab11fbb1b7f8777493811c836196740a3b8f8e951b494c24991ff.jpeg",
    "https://cdn.faire.com/fastly/99e975cd3dd54ed0e65c9af5defb2724f9d2a144d4f16424d5eba2ca187765bd.jpeg",
    "https://cdn.faire.com/fastly/e905299ebf60a9a716c18bd0d111c686e98f2685ae50ec17f954482488815cd4.jpeg",
    "https://cdn.faire.com/fastly/4e26a92bcb3a3e43a55cd808f5224c9225e0c3d6c7b20b5ae355dbecce33d828.jpeg",
    "https://cdn.faire.com/fastly/bcc40628ad1ac027a1808cda10d2c730b479adb15da965de82ced73c75ae6358.jpeg",
    "https://cdn.faire.com/fastly/033877deccf26632c9fbb218b1b5ed595873948f20475b5ec1c4ef1a4ffe5670.jpeg"
  ],
  priceDollars: 6.75,
  description: "Limited Availability - Will Not Restock\n\nSoft, sweet, and just a little smug, these socks will make you seem innocent and blameless with every step you take. Halo not included.\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance. \n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:36:32.456Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
